import script from "./bank-accounts.vue?vue&type=script&setup=true&lang=js"
export * from "./bank-accounts.vue?vue&type=script&setup=true&lang=js"

import "./bank-accounts.vue?vue&type=style&index=0&id=231b1c74&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-231b1c74"]])

export default __exports__